import Text from '@/components/ui/custom/dataDisplay/Text';

type Props = {
  version?: number;
};

export default function CoursePathVersion(props: Props) {
  const { version } = props;

  if (!version) return null;

  return (
    <Text
      format="rubik-500"
      text={`v${version.toFixed(1)}`}
      className="text-14 text-secondary shrink-0"
    />
  );
}
